import { Component, OnInit } from '@angular/core';
import { environment } from '../.././environments/environment';

@Component({
  selector: 'app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent implements OnInit {

  constructor() { }
  public envType = environment.key;
  public showEnvWarning: boolean = false;

  ngOnInit(): void {
    this.showEnvWarning = this.envType == 'stage' || this.envType == 'dev';
  }

}
